<script setup>
import SectionTitle from '@weathernews/btos-vuecomponent/with-onebox-common-elements/src/components/SectionTitle.vue'
import { getLocation } from '@weathernews/btos-javascript-modules/src/wniutil/gps.js'

const tabList = [
  { text: '全国', key: 'all' },
  { text: '現在地', key: 'around' }
]
const selectedTab = ref('all')
const gps = ref([])

const onClickTab = async (key) => {
  if (key === 'around') {
    try {
      const location = await getLocation()
      gps.value = [location.lon, location.lat]
      return selectedTab.value = key
    } catch (error) {
      console.error('現在地情報取得に失敗:', error)
      gps.value = null
      return selectedTab.value = 'all'
    }
  }
  return selectedTab.value = key
}
</script>

<template>
  <div class="riverCurrent">
    <div class="head">
      <SectionTitle title="現在の様子" />
      <div class="tabs">
        <p
          v-for="tab in tabList"
          :key="tab.key"
          :data-selected="tab.key === selectedTab"
          class="tab"
          @click="onClickTab(tab.key)"
        >
          {{ tab.text }}
        </p>
      </div>
    </div>
    <div class="content">
      <RiverAllCamera v-if="selectedTab === 'all'" />
      <RiverAroundCamera
        v-if="selectedTab === 'around'"
        :gps="gps"
      />
    </div>
    <p class="lead">
      河川の水位が高くなると、危険な地点のライブカメラが優先的に表示されます。
    </p>
  </div>
</template>

<style lang="scss" scoped>
.riverCurrent {
  display: flex;
  flex-direction: column;
  gap: 10px;
  .head {
    display: flex;
    justify-content: space-between;
    .tabs {
      display: flex;
      padding: 4px;
      border-radius: 100vmax;
      border: 1px solid #FFF;
      background-color: #EEF1F8;
      box-shadow: 0 1px 2px 0 rgb(53 105 192 / .4);
      .tab {
        padding: 4px 10px;
        width: 62px;
        color: #303030;
        font-size: 12px;
        font-weight: 600;
        line-height: 1em;
        text-align: center;
        &[data-selected="true"] {
          border-radius: 100vmax;
          background-color: #3569C0;
          box-shadow: 0 1px 2px 0 rgb(53 105 192 / .4);
          color: #FFF;
        }
      }
    }
  }
  .content {
    min-height: calc((100vw - 20px) / 16 * 9 + 57px);
  }
  .lead {
    color: #303030;
    font-size: 11px;
    font-weight: 300;
    line-height: 1.5em;
  }
}
@media screen and (min-width: 830px) {
  .riverCurrent {
    .head {
      .tabs {
        .tab {
          font-size: 14px;
        }
      }
    }
    .content {
      min-height: 274px;
    }
    .lead {
      font-size: 16px;
    }
  }
}
</style>
